<section class="text-gray-600 body-font">
  <div class="container mx-auto flex px-5 py-24 items-center justify-center flex-col">
    <img alt="softnet computers" aria-label="softnet computers" class="lg:w-2/6 md:w-3/6 w-5/6 mb-10 object-cover object-center rounded" alt="hero"
      src="../../../assets/branding/softnet-logo.webp">



    <div class="text-center lg:w-2/3 w-full">
      <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Our Services</h1>
      <p class="mb-8 leading-relaxed">
        Softnet Computers in Negombo is your one-stop shop for all computer-related services. We have a team of skilled and experienced technicians who are ready to help you with whatever you need — whether it's repairs, maintenance, or custom solutions. Our aim is to provide fast, reliable, and affordable services to keep you up and running without any worries.
      </p>

      <ul class="mb-8 leading-relaxed list-disc list-inside text-left">
        <li><strong>Computer repairs:</strong> We repair all brands and models of desktop and laptop computers.</li>
        <li><strong>Laptop repairs:</strong> From broken screens to faulty batteries, we handle all kinds of laptop issues.</li>
        <li><strong>Gaming PC builds:</strong> We can custom-build a powerful gaming PC to match your preferences and budget.</li>
        <li><strong>Software installation:</strong> We install and update all necessary software, including operating systems, antivirus, and productivity suites.</li>
        <li><strong>Network setup:</strong> We help you set up home or small office networks, routers, and wireless connections.</li>
        <li><strong>Other services:</strong> We also provide hardware upgrades, data backup, peripheral repairs, and technical support.</li>
      </ul>
      <p class="mb-8 leading-relaxed">
        Softnet Computers is committed to delivering quality service and customer satisfaction. Whatever your computing needs, we’re here to help.
      </p>



    </div>

    <div class="text-center lg:w-2/3 w-full">
      <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">About Us</h1>
      <p class="mb-8 leading-relaxed">Softnet Computers offers the highest quality of Used Computers,New Computers, Computer Parts , Accessories & Desktop-
        Laptop Repairing on the market today. Since 2010, we have provided superior service to our customers and have assisted them in achieving their goals.
        <br>
        <br>

        Our Values,
        Leadership At Softnet Computers, you receive the kind of quality and service you expect from a leader. Our company is always evolving as the needs or
        our customers change and as new opportunities are created in the market. You can rest assured that, working with Softnet Computers, you will enjoy the
        latest services, technology and developments in the industry.
        <br>
        <br>
        Customer Relations,
        At Softnet Computers, our highest priority is satisfied customers. You are important to us and you can expect us to go the extra mile for your business.
        Superior customer service is the hallmark of Softnet Computers. We are proud to serve you and work hard to earn your business
      </p>



    </div>
  </div>
</section>
<app-footer></app-footer>